import { render, staticRenderFns } from "./clickWeibo.vue?vue&type=template&id=9f96b0d6&scoped=true"
import script from "./clickWeibo.vue?vue&type=script&lang=js"
export * from "./clickWeibo.vue?vue&type=script&lang=js"
import style0 from "./clickWeibo.vue?vue&type=style&index=0&id=9f96b0d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f96b0d6",
  null
  
)

export default component.exports